import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { DEPT_TABS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/tabs/")({
  component: () => <DeptContentList cfg={DEPT_TABS} />,
});
